module.exports = __webpack_public_path__ + "static/media/article1.b06a5a72.jpg";